import { render, staticRenderFns } from "./GrainBeans.vue?vue&type=template&id=184cda2a&scoped=true&"
import script from "./GrainBeans.vue?vue&type=script&lang=js&"
export * from "./GrainBeans.vue?vue&type=script&lang=js&"
import style0 from "./GrainBeans.vue?vue&type=style&index=0&id=184cda2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cda2a",
  null
  
)

export default component.exports